import { Layout } from 'antd';
import styled from 'styled-components';

export const Container = styled(Layout.Header)`
  padding: 0 14px 0 24px;
`;
